import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { money } from "@/lib/brand";

const contents = ["Opening dedication", "How it all began", "The moments that stayed", "The little things about you", "The memory I’ll never forget", "What you mean to me", "A final letter"];
const Photo = ({ name, alt, title, note, className, testId }) => <figure className={className} data-testid={testId}>
  <div className="product-photo"><img src={`/images/approved/${name}-960.webp`} srcSet={`/images/approved/${name}-640.webp 640w, /images/approved/${name}-960.webp 960w`} sizes="(max-width: 767px) 100vw, 40vw" loading="lazy" width="960" height="1200" alt={alt}/></div>
  <figcaption><i>{title}</i><span>{note}</span></figcaption>
</figure>;
const ContentsPage = () => <figure className="product-contents" data-testid="product-contents">
  <div className="contents-page" aria-label="The starting chapter plan">
    <p className="contents-title">Contents</p>
    <ol>{contents.map((c, i) => <li key={c}><span>{String(i + 1).padStart(2, "0")}</span>{c}</li>)}</ol>
  </div>
  <figcaption><i>The starting chapter plan</i><span>Keep it, or rename every chapter.</span></figcaption>
</figure>;
export const TheBook = ({ price }) => {
  const facts = [["Format", "Printed softcover"], ["Length", "50 to 150+ pages, you choose"], ["Inside", "Your memories, photos, a dedication and illustrations"], ["Price", price ? money(price) : "See checkout"]];
  return <section id="the-book" className="product-section" aria-labelledby="the-book-title" data-testid="book-introduction">
    <div className="brand-container">
      <div className="product-intro">
        <p className="eyebrow label-rule">The Keepsake Storybook</p>
        <h2 id="the-book-title" className="display-l">A whole story. <em>Just for them.</em></h2>
        <p className="lede">A printed book written from your memories. Their names, your places, the inside jokes and the photographs, shaped into chapters under a cover made for one person.</p>
      </div>
      <div className="product-gallery">
        <Photo className="product-main" testId="product-photo-main" name="shaadi-could-never" title="Shaadi.com Could Never" note="Every cover carries its own title." alt="A Keepsake softcover titled Shaadi.com Could Never, held in hand against a city sunset"/>
        <ContentsPage/>
        <Photo className="product-side" testId="product-photo-side" name="best-part-of-the-playlist" title="She Was the Best Part of the Playlist" note="Softcover, shown in hand." alt="A Keepsake softcover titled She Was the Best Part of the Playlist, held in hand beside a window"/>
      </div>
      <div className="product-footer">
        <dl className="product-facts" data-testid="product-facts">{facts.map(([k, v]) => <div key={k}><dt>{k}</dt><dd data-testid={`product-fact-${k.toLowerCase()}`}>{v}</dd></div>)}</dl>
        <Link to="/create/new" className="btn-primary" data-testid="product-create-cta">Start Your Book <ArrowRight size={16}/></Link>
      </div>
    </div>
  </section>;
};
